export const layLessSports = ["7", "2147483666", "2147483999", "4339"];
export const timelessSports = ["2378961"];
export const headerSports = new Map([
  ["soccer", { id: "1", name: "soccer" }],
  ["cricket", { id: "4", name: "cricket" }],
  ["tennis", { id: "2", name: "tennis" }],
]);
